import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "pis-tree-node" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm mx-2 mt-1 mb-2",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "form-check d-flex" }
const _hoisted_7 = ["checked", "disabled", "id"]
const _hoisted_8 = ["for"]
const _hoisted_9 = {
  key: 0,
  class: "text-primary pis-hover rounded-2 text-nowrap px-1"
}
const _hoisted_10 = {
  key: 1,
  class: "pis-hover text-nowrap rounded-2 px-1"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_13 = {
  key: 0,
  class: "pis-tree"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_ClassificationNode = _resolveComponent("ClassificationNode", true)!
  const _component_TransitionHeight = _resolveComponent("TransitionHeight")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLeaf)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            glyph: "plus",
            sm: "",
            class: "me-1 p-2",
            style: {"opacity":"0"}
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.isExpanded)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleNode && _ctx.toggleNode(...args)), ["prevent"])),
                        class: "text-dark me-1 pis-hover p-2 d-flex rounded-circle"
                      }, [
                        _createVNode(_component_Icon, {
                          glyph: "arrow-right",
                          sm: "",
                          style: {"transform":"rotate(90deg)"}
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleNode && _ctx.toggleNode(...args)), ["prevent"])),
                        class: "text-dark me-1 pis-hover p-2 d-flex rounded-circle"
                      }, [
                        _createVNode(_component_Icon, {
                          glyph: "arrow-right",
                          sm: ""
                        })
                      ]))
                ], 64))
          ], 64)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          class: "form-check-input me-2",
          type: "checkbox",
          checked: _ctx.isSelected,
          disabled: !_ctx.item.selectable,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSelection && _ctx.toggleSelection(...args))),
          id: 'cid_' + _ctx.item.cid
        }, null, 40, _hoisted_7),
        _createElementVNode("label", {
          for: 'cid_' + _ctx.item.cid,
          class: _normalizeClass(["form-check-label user-select-none opacity-100 d-flex align-items-center", [_ctx.item.match && 'bg-light']]),
          onDblclick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleNode && _ctx.toggleNode(...args)), ["prevent"]))
        }, [
          (_ctx.isValidPg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_Tooltip, {
                  trigger: "hover",
                  delay: 200,
                  text: _ctx.item.productGroup.code + ' - ' + _ctx.item.productGroup.name
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item.name), 1)
                  ]),
                  _: 1
                }, 8, ["text"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.item.name), 1))
        ], 42, _hoisted_8),
        (_ctx.isInvalidPg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_Tooltip, {
                trigger: "hover",
                text: _ctx.t('InvalidProductGroup'),
                delay: 100
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    glyph: "warning",
                    sm: "",
                    class: "ms-1 text-warning"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]))
          : (_ctx.areFavoritesEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_Tooltip, {
                  trigger: "hover",
                  text: _ctx.t('FavoritesTooltip'),
                  delay: 100
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["pis-hover p-1 d-flex rounded-circle", [_ctx.isFavorite && 'text-warning', !_ctx.isFavorite && 'text-secondary']]),
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_Icon, {
                        glyph: "star",
                        sm: ""
                      })
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["text"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_TransitionHeight, null, {
      default: _withCtx(() => [
        (_ctx.item.children && _ctx.isExpanded)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
                return (_openBlock(), _createBlock(_component_ClassificationNode, {
                  key: child.cid,
                  item: child,
                  t: _ctx.t,
                  "instance-id": _ctx.instanceId
                }, null, 8, ["item", "t", "instance-id"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}